// ==========================================================================
// Groots Methods
// ==========================================================================

// Copy the values of all properties from a source object to a target object
export const objectAssign = Object.assign || function (srcObj) { // eslint-disable-line
    for (var i = 1; i < arguments.length; i++) {
        for (var objProperty in arguments[i]) {
            if (Object.prototype.hasOwnProperty.call(arguments[i], objProperty)) srcObj[objProperty] = arguments[i][objProperty];
        }
    }
    return srcObj;
};

// Delays invoking function until after limit in milliseconds have elapsed since the last time the function was invoked
export const throttle = function (func, limit) {
    let lastFunc;
    let lastRan;

    return function() {
        const context = this;
        const args = arguments;

        if (!lastRan) {
            func.apply(context, args);
            lastRan = Date.now();
        } else {
            clearTimeout(lastFunc);
            lastFunc = setTimeout(function() {
                if ((Date.now() - lastRan) >= limit) {
                    func.apply(context, args);
                    lastRan = Date.now();
                }
            }, limit - (Date.now() - lastRan));
        }
    };
};

// Delays invoking function until event stop, can add delay
export const debounce = function (func, delay) {
    let inDebounce;

    return function() {
        const context = this;
        const args = arguments;
        clearTimeout(inDebounce);
        inDebounce = setTimeout(() => func.apply(context, args), delay);
    };
};

// Check if viewport is larger than breakpoint (based on breakpoints defined in SASS)
export const minWidth = function (breakpoint) {
    if (typeof(breakpoint) === 'undefined') breakpoint = 'md';

    return window.innerWidth >= parseInt(window.groots.breakpoints[breakpoint], 10);
};

// Check if viewport is smaller than breakpoint (based on breakpoints defined in SASS)
export const maxWidth = function (breakpoint) {
    if (typeof(breakpoint) === 'undefined') breakpoint = 'md';

    return window.innerWidth < parseInt(window.groots.breakpoints[breakpoint], 10) - 1;
};

// Check if touch device
export const isTouch = function () {
    return 'ontouchstart' in window ||
        window.DocumentTouch && document instanceof window.DocumentTouch ||
        navigator.maxTouchPoints > 0 ||
        window.navigator.msMaxTouchPoints > 0;
};

// Check if element is visible
export const isVisible = function (el) {
    var windowWidth = window.innerWidth,
        windowHeight = window.innerHeight;
    if (windowWidth === null || windowHeight === null) return false;
    var rect = el.getBoundingClientRect();
    var elTop = rect.top;
    var elLeft = rect.left;
    var elWidth = rect.width;
    var elHeight = rect.height;
    return elTop < windowHeight && elTop + elHeight > 0 && elLeft < windowWidth && elLeft + elWidth > 0;
};

// Add an attribute value
export const addAttributeValue = function (el, attribute, value, toggleClass) {
    if (toggleClass === undefined) toggleClass = false;
    if (!el || !el.hasAttribute(attribute)) return;

    var values = el.getAttribute(attribute).split(' ');
    var existingIndex = values.indexOf(value);

    if (existingIndex < 0) values.push(value);
    if (toggleClass) el.classList.add('gr-' + value);

    el.setAttribute(attribute, values.join(' '));
};

// Remove attribute value(s)
export const removeAttributeValue = function (el, attribute, value, removeClass) {
    if (removeClass === undefined) removeClass = false;
    if (!el || !el.hasAttribute(attribute)) return;
    var values = el.getAttribute(attribute).split(' ');

    var valuesToRemove = value.split(' ');

    for (var i = valuesToRemove.length - 1; i >= 0; i--) {
        var existingIndex = values.indexOf(valuesToRemove[i]);
        if (existingIndex >= 0) values.splice(existingIndex, 1);
        if (removeClass) el.classList.remove('gr-' + valuesToRemove[i]);
    }

    el.setAttribute(attribute, values.join(' '));
};

// Toggle an attribute value
export const toggleAttributeValue = function (el, attribute, value, toggleClass) {
    if (toggleClass === undefined) toggleClass = false;
    if (!el || !el.hasAttribute(attribute)) return;

    var values = el.getAttribute(attribute).split(' ');
    var existingIndex = values.indexOf(value);

    if (existingIndex >= 0) values.splice(existingIndex, 1);
    else values.push(value);
    if (toggleClass) el.classList.toggle('gr-' + value);

    el.setAttribute(attribute, values.join(' '));
};

// Check if element has attribute value
export const hasAttributeValue = function (el, attribute, value) {
    if (!el || !el.hasAttribute(attribute)) return;

    var values = el.getAttribute(attribute).split(' ');
    var existingIndex = values.indexOf(value);

    if (existingIndex >= 0) {
        return true;
    } else {
        return false;
    }
};

// Get closest ancestor element with given selector
export const getClosest = function (el, selector) {
    for (; el && el !== document; el = el.parentNode) {
        if (el.matches(selector)) return el;
    }

    return null;
};

// Get coordinates of element
export const offset = function (el) {
    el = el.getBoundingClientRect();
    var scrollTop = window.pageYOffset;

    return {
        left: el.left + window.scrollX,
        top: el.top + scrollTop,
    };
};

// Replace %s variables in a string
export const sprintf = function sprintf(template, values) {
    return template.replace(/%s/g, function() {
        return values.shift();
    });
};

// Wrap wrapper around nodes
export const wrapAll = function (nodes, wrapper) {
    // Cache the current parent and previous sibling of the first node.
    var parent = nodes[0].parentNode;
    var previousSibling = nodes[0].previousSibling;

    // Place each node in wrapper.
    //  - If nodes is an array, we must increment the index we grab from
    //    after each loop.
    //  - If nodes is a NodeList, each node is automatically removed from
    //    the NodeList when it is removed from its parent with appendChild.
    for (var i = 0; nodes.length - i; wrapper.firstChild === nodes[0] && i++) {
        wrapper.appendChild(nodes[i]);
    }

    // Place the wrapper just after the cached previousSibling,
    // or if that is null, just before the first child.
    var nextSibling = previousSibling ? previousSibling.nextSibling : parent.firstChild;
    parent.insertBefore(wrapper, nextSibling);

    return wrapper;
};

// Easing function
export const easeOutCubic = function (time) {
    return (--time) * time * time + 1;
};
